import React from 'react';
import HorizontalLight from './horizontal-light';
import HorizontalDark from './horizontal-dark';
import VerticalLight from './vertical-light';
import VerticalDark from './vertical-dark';
import Compact from './compact-dark';
import { Direction } from '../../constants';
const LogoVariations = {
  dark: {
    [Direction.vertical]: VerticalDark,
    [Direction.horizontal]: HorizontalDark,
    [Direction.compact]: Compact
  },
  light: {
    [Direction.vertical]: VerticalLight,
    [Direction.horizontal]: HorizontalLight,
    [Direction.compact]: Compact // TODO: review if we should provide a light version of compact
  }
};

// Using color prop to provide light / dark. Default to dark.
const UniversalLogo = props => {
  const {
    outline,
    direction = Direction.horizontal,
    color,
    variation = color === 'light' ? 'light' : 'dark',
    ...rest
  } = props;
  const Vector = LogoVariations[variation][direction];
  return /*#__PURE__*/React.createElement(Vector, rest);
};
export default UniversalLogo;
//# sourceMappingURL=index.js.map